import { useCallback } from "react";
import { useSWRConfig } from "swr";
/**
 * Clears the cache of the SWR data for the entire application.
 *
 * @param {void} None
 * @return {void} None
 */
export const useClearSWR = () => {
    const { cache } = useSWRConfig();
    return useCallback(() => {
        const keys = cache.keys();
        [...keys].forEach((key) => {
            cache.delete(key);
        });
    }, [cache]);
};
